import { useCallback, useRef } from 'react';

export const useIncrementedID = () => {
	const nextIDRef = useRef(1);

	const getID = useCallback(() => {
		const id = nextIDRef.current;
		nextIDRef.current += 1;
		return id;
	}, []);

	return { getID };
};
